import React, { memo, useCallback } from "react";
import { NumberSpin } from "../../../../../Components/Spin/NumberSpin";
import { PurpleButton } from "../../../../../Components/Buttons/PurpleButton";
import { WhiteButton } from "../../../../../Components/Buttons/WhiteButton";
import {
  MintGuestsIcon,
  MintBedroomsIcon,
  MintBedsIcon,
  MintBathroomsIcon,
} from "../../../../../AssetComponents/Images";
import Meters from "../../../../../assets/images/Dashboard/Dashboard/Meters";

const MintEssentialsPage = memo(({
  metaDetails,
  setMetaDetails,
  onBack,
  onNext,
}) => {
  // Memoize onChange handlers to prevent unnecessary re-renders
  const handleGuestsChange = useCallback((value) => {
    setMetaDetails((prev) => ({
      ...prev,
      essentials: { ...prev.essentials, guests: value },
    }));
  }, [setMetaDetails]);

  const handleBedroomsChange = useCallback((value) => {
    setMetaDetails((prev) => ({
      ...prev,
      essentials: { ...prev.essentials, bedrooms: value },
    }));
  }, [setMetaDetails]);

  const handleBedsChange = useCallback((value) => {
    setMetaDetails((prev) => ({
      ...prev,
      essentials: { ...prev.essentials, beds: value },
    }));
  }, [setMetaDetails]);

  const handleBathroomsChange = useCallback((value) => {
    setMetaDetails((prev) => ({
      ...prev,
      essentials: { ...prev.essentials, bathrooms: value },
    }));
  }, [setMetaDetails]);

  const handleSquareChange = useCallback((e) => {
    setMetaDetails((prev) => ({
      ...prev,
      essentials: {
        ...prev.essentials,
        square: e.target.value,
      },
    }));
  }, [setMetaDetails]);
  return (
    <div className="justify-center flex items-center w-full h-full">
      <div className="space-y-[10px] p-[20px] bg-white border-[2px] border-[#E3E3E3] rounded-[10px] flex flex-col items-center">
        <div className="font-semibold text-[20px]">
          Share some basic about your place
        </div>
        <div className="text-[#595959] text-center max-w-[300px]">
          You'll add more details later
        </div>
        
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            <MintGuestsIcon />
            <div>Guests</div>
          </div>
          <NumberSpin
            value={metaDetails.essentials.guests}
            min={1}
            onChange={handleGuestsChange}
          />
        </div>
        
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            <MintBedroomsIcon />
            <div>Bedrooms</div>
          </div>
          <NumberSpin
            value={metaDetails.essentials.bedrooms}
            onChange={handleBedroomsChange}
          />
        </div>
        
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            <MintBedsIcon />
            <div>Beds</div>
          </div>
          <NumberSpin
            value={metaDetails.essentials.beds}
            onChange={handleBedsChange}
          />
        </div>
        
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            <MintBathroomsIcon />
            <div>Bathrooms</div>
          </div>
          <NumberSpin
            value={metaDetails.essentials.bathrooms}
            onChange={handleBathroomsChange}
          />
        </div>
        
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            <Meters />
            <div>Meters</div>
          </div>
          <div className="flex items-center border-[2px] rounded-md w-[98px] px-1">
            <input
              value={metaDetails.essentials.square}
              onChange={handleSquareChange}
              className="outline-none w-full text-center pl-2"
              min={1}
            />
            <div className="text-[#959595] text-[14px] items-top flex">
              <span>M</span>
              <span className="text-[10px] top-0">2</span>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-row gap-3 px-4 py-3 bg-white border-t border-gray-200 shadow-lg">
          <WhiteButton  
            text="Back"
            onClick={onBack} 
            className="flex-1 h-[45px] flex items-center justify-center text-sm font-medium"
          />
          <PurpleButton
            text="Next"
            onClick={onNext}
            className="flex-1 h-[45px] flex items-center justify-center text-sm font-medium"
          />
        </div>
      </div>
    </div>
  );
});

MintEssentialsPage.displayName = "MintEssentialsPage";

export default MintEssentialsPage;
